//src/pages/NavDetails/TalkToUs.jsx
import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { MdMail, MdPhoneInTalk } from "react-icons/md";
import { sendContactEmail } from "../../api/admin/adminApi";
import TermsAndPolicyFooter from "../../components/common/PrivacyPolicy/CompanyTermsAndPolicy/TermsAndPolicyFooter";

const TalkToUs = () => {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setSent(false);

    const payload = Object.fromEntries(new FormData(e.target).entries());

    try {
      await sendContactEmail(payload);
      setSent(true);
      e.target.reset();
    } catch (err) {
      console.error(err);
      alert("Failed to send. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-white relative overflow-hidden">

   
      {/* <div className="absolute top-0 left-0 w-72 h-72 bg-purple-400 opacity-20 blur-3xl rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-400 opacity-20 blur-3xl rounded-full"></div> */}

     
      <div className="flex-1 flex flex-col items-center px-4 py-16">

      
        <h1 className="text-4xl md:text-5xl font-extrabold text-center mb-12 
        bg-gradient-to-l from-indigo-950 to-indigo-800 text-transparent bg-clip-text">
          We are here to help!
        </h1>

        
        <div className="w-full max-w-6xl rounded-3xl overflow-hidden 
        bg-white/60 backdrop-blur-xl border border-white/40 
        shadow-[0_20px_60px_rgba(0,0,0,0.1)] 
        flex flex-col md:flex-row">

       
          <div className="md:w-1/3 p-8 md:p-10 border-b md:border-b-0 md:border-r border-white/30">

            <h3 className="text-2xl font-semibold mb-10 leading-snug text-[#36369f]">
              Have Queries? <br /> Let’s Discuss
            </h3>

            <div className="space-y-6 text-gray-700">

              <a href="mailto:contact@myassessment.ai" className="flex items-center gap-3 hover:text-purple-600 transition">
                <MdMail className="text-xl text-blue-500" />
                <span>contact@myassessment.ai</span>
              </a>

              <a
                href="https://wa.me/917337221008"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 hover:text-purple-600 transition"
              >
                <FaWhatsapp className="text-xl text-green-500" />
                <span>WhatsApp</span>
              </a>

              <div className="flex items-center gap-3">
                <MdPhoneInTalk className="text-xl text-purple-500" />
                <span>+91 73372 21008</span>
              </div>

            </div>
          </div>

          
          <form
            onSubmit={handleSubmit}
            className="md:w-2/3 p-8 md:p-10 flex flex-col justify-between"
          >

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                { name: "firstName", ph: "First Name*", type: "text" },
                { name: "lastName", ph: "Last Name*", type: "text" },
                { name: "email", ph: "Email ID*", type: "email" },
                { name: "phone", ph: "Phone Number*", type: "tel" },
                { name: "company", ph: "Company Name*", type: "text" },
                { name: "country", ph: "Country*", type: "text" },
              ].map(({ name, ph, type }) => (
                <input
                  key={name}
                  name={name}
                  type={type}
                  placeholder={ph}
                  className="border-b-2 bg-transparent py-2 focus:outline-none 
                  border-gray-300 focus:border-purple-500 transition"
                  required
                />
              ))}
            </div>

            <textarea
              name="message"
              rows={3}
              placeholder="Message*"
              className="mt-6 w-full border-b-2 bg-transparent py-2 resize-none focus:outline-none 
              border-gray-300 focus:border-purple-500 transition"
              required
            />

            <p className="text-sm mt-6 mb-4 text-gray-600">
              By clicking on Submit, you agree to receive updates via email and
              call from myassessment.ai
            </p>

            <button
              type="submit"
              disabled={sending}
              className="self-start px-10 py-3 rounded-xl text-white font-semibold 
              bg-gradient-to-l from-indigo-950 to-indigo-800 
              shadow-lg hover:scale-105 hover:shadow-xl 
              transition-all duration-300 disabled:opacity-60"
            >
              {sending ? "Sending…" : sent ? "Sent!" : "Submit"}
            </button>

          </form>

        </div>

      </div>

      
      <TermsAndPolicyFooter />

    </div>
  );
};

export default TalkToUs;